import { type SpinnerProps } from '../constants/ui'
import '../styles/spinner.scss'

export function Spinner({ label, block = false, inline = false }: SpinnerProps) {
  const className = [
    'spinner',
    block ? 'spinner--block' : '',
    inline ? 'spinner--inline' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const content = (
    <>
      <span className="spinner__dot" aria-hidden />
      {label ? <span className="spinner__label">{label}</span> : null}
    </>
  )

  if (inline) {
    return (
      <span className={className} role="status" aria-live="polite" aria-busy="true">
        {content}
      </span>
    )
  }

  return (
    <div className={className} role="status" aria-live="polite" aria-busy="true">
      {content}
    </div>
  )
}
